<template>
   <div>
    <button>
       <router-link :to="{ name: 'owner-terminal-transactions', query: {branchName: data.branchName, paymentDate: data.paymentDate}}" class="btn dealers_btn ">
        {{$t('text.clickButtons.details')}}
       </router-link>
    </button>
   </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
  data() {
    return {
      data: {},
    };
  },
  mounted() {
      
  },
  methods: {
      
  },
};
</script>